import commissioner_template from './templates/commissioner_template.jst';
import non_commissioner_template from './templates/non_commissioner_template.jst';
import './index.styl';
import { CoreLeagueSettingsView } from '../../../../../core/views';
import Radio from "backbone.radio";

const celebrityPopupChannel = Radio.channel( 'celebrity_popup' );

/**
 * @desc League Settings View Class
 * This class using on league settings page ('league/:league_id/manage')
 */
export default class LeagueSettingsView extends CoreLeagueSettingsView {
	get template() {
		return non_commissioner_template;
	}

	regions() {
		return {
			'celebrity_popup': '.celebrity-popup'
		}
	}

	get className() {
		return "league-settings-page shadow";
	}

	getTemplate() {
		if ( !this.is_commissioner ) {
			return non_commissioner_template;
		}
		else {
			celebrityPopupChannel.trigger( 'update:popup' );
			return commissioner_template;
		}
	}
}